import React, { useEffect } from 'react'
import AboutAnalysis from './AboutAnalysis'
import AboutBanner from './AboutBanner'
import AboutPlatform from './AboutPlatform'
import AboutTrusted from './AboutTrusted'
import BecomePartner from './BecomePartner'
import TechnologyPartners from './TechnologyPartners'
import VisionMission from './VisionMission'
import Faq from './Faq'
// import { useLocation } from 'react-router-dom'
// import { Helmet } from "react-helmet";

const AboutUs = (props) => {
    // =========================== scroll To Top default =========================
    useEffect(() => {
        props.demo('top')
    }, [])
    // =========================== scroll To Top default =========================
    // const { pathname } = useLocation();
    // console.log("pathname", pathname);
    return (
        <>
            {/* <Helmet>
                <link rel="canonical" href={`https://infograins.com/aboutUs`} />
            </Helmet> */}
            <AboutBanner />
            <AboutAnalysis />
            <AboutPlatform />
            <AboutTrusted />
            <VisionMission />
            <TechnologyPartners />
            <BecomePartner />
            <Faq />
        </>
    )
}

export default AboutUs